export default __webpack_public_path__ + "static/sutherland-13fc02b53c331c7a0b97105fe04b9931.svg";